import React, { FC } from 'react';
import { defaultDashboard } from '../../../constants/dashboardConstants';
import DashboardItem from '../dashboardItem/dashboardItem';

interface DashboardLayoutProps {
  layoutData?: any,
  setNewLayout?: (_newLayout: any) => void,
  isDefaultDashboard?: boolean,
}

const DashboardLayout: FC<DashboardLayoutProps> = (props) => {
  const onLayoutChange = async (newLayout: any) => {
    await props.setNewLayout?.(newLayout);
  };

  if (props.layoutData?.layout && !props.isDefaultDashboard) {
    return (
      <DashboardItem
        key={`custom-dashboard-${props.layoutData?.id}`}
        onLayoutChange={onLayoutChange}
        layout={JSON.parse(props.layoutData.layout)}
      />
    );
  }

  return (
    <DashboardItem
      key="default-dashboard"
      layout={defaultDashboard}
    />
  );
};

export default DashboardLayout;
